import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';

import { AccordionComponent, AccordionContent, AccordionItem } from '@mds/ui';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { AnalyzeService } from '@services/analyze.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as Highcharts from 'highcharts';
import { FormatNumberPipe, NewUiRoute } from '@mds/common';

@Component({
  selector: 'app-performance-analytics',
  standalone: true,
  imports: [MdsIconsModule, AccordionComponent, AccordionItem, AccordionContent, FormatNumberPipe, NewUiRoute],
  providers: [],
  templateUrl: './performance-analytics.component.html',
  styleUrls: ['./performance-analytics.component.scss']
})
export class PerformanceAnalyticsComponent implements AfterViewInit, OnChanges {
  openedSidePanel = true;
  analyticsData: any;
  @Input() data: any;
  @Input() app: any;
  @Output() isSidePanelOpen: EventEmitter<boolean> = new EventEmitter();
  @ViewChildren('chartContainer') chartContainers!: QueryList<ElementRef>;
  private readonly destroyRef = inject(DestroyRef);
  icons = MdsIcon;
  selectionText = 'Performance';
  contextualTools = [
    {
      name: 'Applied pins',
      list: []
    }
  ];
  appName: string;
  analyticsDataSummary: any;
  totalDeltaValue: string;
  totalPercentage: string;
  constructor(private analyzeService: AnalyzeService, private el: ElementRef) {}
  ngOnChanges() {
    this.appName = this.app.app_name;
  }

  ngAfterViewInit() {
    this.analyzeService
      .getAnalyzeData()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.createAnalytics(res);
        setTimeout(() => {
          this.drawChart();
        }, 1000);
      });
  }
  createAnalytics(res) {
    this.analyticsData = res?.analytics?.pin_deltas;
    this.analyticsDataSummary = res?.analytics?.pin_deltas_summary[0];
    const totalDeltaValue = this.analyticsDataSummary?.total_delta;
    const sign = this.analyticsDataSummary?.total_delta > 0 ? 1 : -1;
    this.totalDeltaValue = isNaN(totalDeltaValue) ? '0%' : (sign * totalDeltaValue).toFixed(2);
    const percent = this.analyticsDataSummary?.total_change_percentage
      ? this.analyticsDataSummary.total_change_percentage
      : 0;
    this.totalPercentage = `${percent.toFixed(2)}%`;
  }

  toggleSidePanel() {
    this.openedSidePanel = !this.openedSidePanel;
    this.isSidePanelOpen.emit(this.openedSidePanel);
  }

  drawChart() {
    this.chartContainers.forEach((container, index) => {
      const deltaValue = this.analyticsData[index]?.delta || 0;
      const percentValue = Math.abs(deltaValue);
      const color = deltaValue <= 0 ? '#01C9B3' : '#E82E3C';
      Highcharts.chart(container.nativeElement, {
        chart: {
          type: 'pie',
          backgroundColor: 'transparent',
          spacing: [0, 0, 0, 0],
          width: 75,
          height: 75
        },
        credits: {
          enabled: false
        },
        title: { text: '' },
        plotOptions: {
          pie: {
            innerSize: '60%',
            dataLabels: { enabled: false }
          }
        },
        legend: { enabled: false },
        tooltip: { enabled: false },
        series: [
          {
            type: 'pie',
            data: [
              {
                y: percentValue,
                color,
                borderWidth: 1,
                borderColor: '#00121C'
              }, // Dynamic delta value
              {
                y: 100 - percentValue,
                color: '#F5F7F8',
                borderWidth: 1,
                borderColor: 'rgba(0, 0, 0, 0.10)'
              } // Remaining part of the chart
            ]
          }
        ]
      });
    });
  }
}
